<t-llevo-overlay-button 
  value="Fecha" 
  matBadge="1" 
  [matBadgeHidden]="!hasValueSelected" 
  matBadgeColor="accent"
  [disableClose]="isDatepickerOpen()"
  [disabled]="disabled"
>
  <div class="bg-white p-1 border shadow">
    @if(selectedFilter == 'range'){
    <mat-form-field>
      <mat-label>Rango</mat-label>
      <mat-date-range-input [formGroup]="range" [rangePicker]="rangePicker" [max]="maxDate">
        <input matStartDate placeholder="Fecha inicial" formControlName="start"/>
        <input (dateChange)="onSubmit()" matEndDate placeholder="Fecha final" formControlName="end" />
      </mat-date-range-input>
      <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle
        matIconSuffix
        [for]="rangePicker"
      ></mat-datepicker-toggle>
      <mat-date-range-picker #rangePicker></mat-date-range-picker>
    </mat-form-field>
    } @else if(selectedFilter == 'after' || 'before'){
    <mat-form-field>
      <mat-label>{{selectedFilter === 'after'? 'Posterior a' : 'Anterior a'}}</mat-label>
      <input matInput [matDatepicker]="picker" (dateChange)="onSubmit()" [max]="maxDate" [formControl]="date"/>
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    }

    <div class="d-block my-3">
      <label>Filtrar:</label>
      <mat-radio-group
        value="range"
        (change)="filterChange($event)"
        (change)="onSubmit()"
        class="d-flex flex-column"
      >
        <mat-radio-button value="range">Rango</mat-radio-button>
        <mat-radio-button value="after">Posterior</mat-radio-button>
        <mat-radio-button value="before">Anterior</mat-radio-button>
      </mat-radio-group>
    </div>
    
    @if(hasValueSelected){
      <button mat-flat-button color="primary" class="w-100" (click)="deleteSelectedValue()">
        Desactivar filtro
      </button>
    }
  </div>
</t-llevo-overlay-button>